module.exports = __webpack_public_path__ + "img/i30_tourer.9c46e100.png";